import axios from "axios";
import { GetAllMobileUserApiResponse, GetMobileUserByIdApiResponse } from "../shared/interface/UserManagement/mobileUser.interface";
import { CommonMessageInterface } from "../shared/interface/UserManagement/user.interface";
import { UserTypeConstants } from "../constants/DatabaseConstants/MasterConstant";

export const getAllUserList = async (showDeleted?: boolean, customerId?: number | null, locationId?: number | null, userType?: UserTypeConstants) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/mobile-user`;

    if (showDeleted) {
      query += `?showDeleted=${showDeleted}`;
    }

    if (customerId) {
      query += `&customerId=${customerId}`;
    }

    if (locationId) {
      query += `&locationId=${locationId}`;
    }

    if (userType) {
      query += `&userType=${userType}`;
    }

    const res = await axios.get(query);

    return res.data as GetAllMobileUserApiResponse;
  } catch (error) {
    throw error;
  }
};

export const getUserById = async (userId: number, showDeleted?: boolean) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/mobile-user/${userId}`;

    if (showDeleted) {
      query += `?showDeleted=${showDeleted}`;
    }

    const res = await axios.get(query);

    return res.data as GetMobileUserByIdApiResponse;
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (userId: number) => {
  try {
    const res = await axios.patch(`${process.env.REACT_APP_API_URL}/mobile-user/change-record-status/${userId}`, {});

    return res.data as CommonMessageInterface;
  } catch (error) {
    throw error;
  }
};
